module.exports = __webpack_public_path__ + "static/media/7.27b10511.jpg";